<template>
  <div>
    <h4
      v-bind="attributesBinding"
      :class="mainExpression == 'Edit' ? 'text-center' : null"
    >
      {{ currentField.value.ja ? currentField.value.ja : currentField.text }}
    </h4>
    <p
      class="ma-0 text-caption"
      v-if="mainExpression == 'Preview' && isLanguage !== 'ja'"
    >
      {{ captionText }}
    </p>
  </div>
</template>


<script>
export default {
  name: "FormElementExplain",
  store: ["mainExpression", "isLanguage"],
  props: ["currentField"],
  computed: {
    attributesBinding() {
      var attr = {};
      if (this.currentField.id) {
        attr.id = `label-${this.currentField.id}`;
      }
      if (this.currentField.color) {
        attr.style = { color: this.currentField.color };
      }
      return attr;
    },
    captionText() {
      if (!this.currentField.value[this.isLanguage]) {
        return "";
      }
      return this.currentField.value[this.isLanguage];
    },
  },
};
</script>
<style scoped>
::v-deep .v-input__slot {
  min-height: 30px !important;
}
p {
  line-height: 1;
}
h4 {
  user-select: none;
  word-wrap: break-word;
  white-space: pre-line;
}
</style>
